import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Truck } from 'lucide-react';
import { api } from '@/lib/api';
import { useWorkspaceId } from '@/lib/hooks';
import { JourneyStatusPill } from './fleetUi';

/** t265u: on a task, the delivery journeys planned for it (fleet.journey_tasks), each linking to the journey. */
export function TaskJourneys({ taskId }: { taskId: string }) {
  const ws = useWorkspaceId();
  const q = useQuery({ queryKey: ['task-journeys', ws, taskId], queryFn: () => api.fleet.taskJourneys(ws!, taskId), enabled: Boolean(ws), retry: false });
  if (!q.data?.length) return null;
  return (
    <section className="mt-5" data-testid="task-journeys">
      <h3 className="mb-1 text-xs font-semibold uppercase tracking-wide text-slate-500">Delivery journeys</h3>
      {q.data.map(j => (
        <Link key={j.id} to={`/fleet/journeys/${j.id}`} className="flex items-center gap-2 py-0.5 text-sm link">
          <Truck className="h-3.5 w-3.5" aria-hidden />{j.ref}
          <span className="text-xs text-slate-500">{new Date(j.planned_start).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' })}</span>
          <JourneyStatusPill s={j.status as never} />
        </Link>
      ))}
    </section>
  );
}

/** t265u: on a journey planned from a task, "From task KEY: title", opening the task. Hidden if you can't see it. */
export function JourneySourceTask({ taskId, onOpen }: { taskId: string; onOpen: (id: string) => void }) {
  const q = useQuery({ queryKey: ['task', taskId], queryFn: () => api.task(taskId), retry: false });
  if (!q.data) return null;
  return (
    <div className="mt-2 text-xs text-slate-500" data-testid="journey-source-task">
      From task <button type="button" className="underline" onClick={() => onOpen(taskId)}>{q.data.key}: {q.data.title}</button>
    </div>
  );
}
